import { createReducer, createAction } from '@reduxjs/toolkit';
import { Loadable } from 'models';

import { WebSocketManager } from 'models';

export interface WebsocketState extends Loadable<boolean> {
    messages: WebSocketManager.MessageCommand[];
    lastMessage: WebSocketManager.MessageCommand | null;
}

const initialState: WebsocketState = {
    status: 'idle',
    messages: [],
    lastMessage: null,
};

export const connect = createAction('socket/connect');

export const connectionEstablished = createAction(
    'socket/connectionEstablished',
);

export const disconnected = createAction('socket/disconnected');

export const error = createAction<any>('socket/error');

export const receiveMessage = createAction<WebSocketManager.MessageCommand>(
    'socket/receiveMessage',
);

export const disconnect = createAction('socket/disconnect');

export const sendData =
    createAction<WebSocketManager.OutgoingCommandTypes>('socket/sendData');

export const webSocketReducer = createReducer(initialState, (builder) => {
    builder.addCase(connect, (state) => {
        return {
            ...state,
            status: 'loading',
        };
    });

    builder.addCase(connectionEstablished, (state) => {
        return {
            ...state,
            status: 'finished',
            object: true,
        };
    });

    builder.addCase(disconnected, (state) => {
        return {
            ...state,
            status: 'idle',
            object: false,
        };
    });

    builder.addCase(error, (state, action) => {
        return {
            ...state,
            error: action.payload,
            object: undefined,
        };
    });

    builder.addCase(receiveMessage, (state, action) => {
        state.messages.push(action.payload);
        state.lastMessage = action.payload;
    });

    // Handled by the middleware
    builder.addCase(disconnect, (state) => state);

    // handled by the middleware
    builder.addCase(sendData, (state) => state);
});

export const websocketActions = {
    connect,
    connectionEstablished,
    disconnected,
    error,
    receiveMessage,
    disconnect,
    sendData,
};

export default webSocketReducer;
